import { useQuery } from '@tanstack/react-query';

import {
  fetchLocations,
  fetchPerformanceTrend,
  fetchProfiles,
  type InsightCommonFetchParams,
} from '@/entities/insight';
import type { Hashtag, Keyword, Location, Profile } from '../../../../entities/post/models';

export interface InsightOverviewData {
  totalVolume: number;
  totalViews: number;
  totalEngagements: number;
  profiles: Profile[];
  locations: Location[];
  keywords: Keyword[];
  hashtags: Hashtag[];
}

export function useOverviewPerformance(params: InsightCommonFetchParams) {
  return useQuery({
    queryKey: [
      'insight-overview-performance',
      params.queryId,
      params.startDate,
      params.endDate,
      params.limit,
      params.publicFilter,
    ],
    queryFn: ({ signal }) =>
      fetchPerformanceTrend(
        {
          ...params,
          period: 'monthly',
        },
        signal,
      ),
  });
}

export function useOverviewProfiles(params: InsightCommonFetchParams) {
  return useQuery({
    queryKey: [
      'insight-overview-profiles',
      params.queryId,
      params.startDate,
      params.endDate,
      params.limit,
      params.publicFilter,
    ],
    queryFn: ({ signal }) => fetchProfiles(params, signal),
  });
}

export function useOverviewLocations(params: InsightCommonFetchParams) {
  return useQuery({
    queryKey: [
      'insight-overview-locations',
      params.queryId,
      params.startDate,
      params.endDate,
      params.limit,
      params.publicFilter,
    ],
    queryFn: ({ signal }) => fetchLocations(params, signal),
  });
}
